import { render, staticRenderFns } from "./TwNewReminder.vue?vue&type=template&id=61af9f13&scoped=true&"
import script from "./TwNewReminder.vue?vue&type=script&lang=js&"
export * from "./TwNewReminder.vue?vue&type=script&lang=js&"
import style0 from "./TwNewReminder.vue?vue&type=style&index=0&id=61af9f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af9f13",
  null
  
)

export default component.exports